import P from 'parsimmon'

/**
 * 將 Python Dict 轉為 JS 物件
 * @param {string} input
 * @returns {any} output
 */
function parse(input) {
  return PyDictParser.value.tryParse(input)
}


// Turn escaped characters into real ones (e.g. "\\n" becomes "\n").
function interpretEscapes(str) {
  let escapes = {
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
  }
  return str.replace(/\\(u[0-9a-fA-F]{4}|[^u])/, (_, escape) => {
    let type = escape.charAt(0)
    let hex = escape.slice(1)
    if (type === 'u') {
      return String.fromCharCode(parseInt(hex, 16))
    }
    if (escapes.hasOwnProperty(type)) {
      return escapes[type]
    }
    return type
  })
}

const whitespace = P.regexp(/\s*/m)

function token(parser) {
  return parser.skip(whitespace)
}

// Several parsers are just strings with optional whitespace.
function word(str) {
  return P.string(str).thru(token)
}

const PyDictParser = P.createLanguage({
  value: r =>
    P.alt(
      r.dict,
      r.list,
      r.string,
      r.number,
      r.null,
      r.true,
      r.false,
      r.pythonDict,
    ).thru(
      parser => whitespace.then(parser)
    ),

  // The basic tokens in TOML, with optional whitespace afterward.
  lbrace: () => word('{'),
  rbrace: () => word('}'),
  lbracket: () => word('['),
  rbracket: () => word(']'),
  comma: () => word(','),
  optionalComma: () => P.regexp(/,?/).skip(whitespace),
  colon: () => word(':'),

  null: () => word('None').result(null),
  true: () => word('True').result(true),
  false: () => word('False').result(false),

  string: () =>
    token(P.regexp(/['"]((?:\\.|.)*?)['"]/, 1))
      .map(interpretEscapes),

  number: () =>
    token(P.regexp(/-?(0|[1-9][0-9]*)([.][0-9]+)?([eE][+-]?[0-9]+)?/))
      .map(Number),


  list: r => r.lbracket
    .then(r.value.sepBy(r.comma))
    .skip(r.optionalComma)
    .skip(r.rbracket),

  pair: r => P.seq(r.string.desc('key').skip(r.colon), r.value),

  dict: r =>
    r.lbrace
      .then(
        r.pair
          .sepBy(r.comma)
          .skip(r.optionalComma)
      )
      .skip(r.rbrace)
      .map(pairs => {
        let object = {}
        pairs.forEach(pair => {
          let [key, value] = pair
          object[key] = value
        })
        return object
      }),

  // dict
  bareString: () =>
    token(P.regexp(/[a-zA-Z_][a-zA-Z0-9_]*/)),

  dictEntry: r =>
    P.seq(r.bareString.skip(P.string('=')), r.value)
      .map(pair => ({[pair[0]]: pair[1]})),

  pythonDict: r =>
    word('dict')
      .then(r.lparen)
      .then(r.dictEntry.sepBy(r.comma).skip(r.optionalComma))
      .skip(r.rparen)
      .map(entries => Object.assign({}, ...entries)),

  lparen: () => word('('),
  rparen: () => word(')'),
})

export default {
  parse,
}